import { IValidationRule } from "@/types"

const stocktakingOrderValidationRules: { [s: string]: IValidationRule } = {
    dueDate: {
        required: true,
    },
}

export default stocktakingOrderValidationRules
